import { useState } from "react";

export const useAgreeTermsStates = () => {
  // 利用規約&個人情報保護基本方針 同意フラグ
  const [checkedAgreement, setCheckedAgreement] = useState(false);

  return {
    checkedAgreement,
    setCheckedAgreement,
  };
};
